// playwright/utils/test-id.ts
function generateModuleId(route) {
  const path = route.replace(/^\/?(app\/)?/, "");
  const kebabCase = path.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  return kebabCase.split("/").pop() || "unknown";
}
function generateTestId(module, suffix) {
  if (suffix) {
    return `${module}-${suffix}`;
  }
  return module;
}
var TEST_ID_PATTERNS = {
  /** 表格 ID */
  table: (module) => `${module}-table`,
  /** 表单 ID */
  form: (module) => `${module}-form`,
  /** 搜索表单 ID */
  searchForm: (module) => `${module}-search-form`,
  /** 弹窗 ID */
  modal: (module) => `${module}-modal`,
  /** 操作按钮组 ID */
  actions: (module) => `${module}-actions`,
  /** 创建按钮 ID */
  createBtn: (module) => `${module}-create-btn`,
  /** 编辑按钮 ID */
  editBtn: (module) => `${module}-edit-btn`,
  /** 删除按钮 ID */
  deleteBtn: (module) => `${module}-delete-btn`,
  /** 查询按钮 ID */
  queryBtn: (module) => `${module}-query-btn`,
  /** 重置按钮 ID */
  resetBtn: (module) => `${module}-reset-btn`
};
function generatePageTestIds(route) {
  const module = generateModuleId(route);
  return {
    module,
    table: TEST_ID_PATTERNS.table(module),
    form: TEST_ID_PATTERNS.form(module),
    searchForm: TEST_ID_PATTERNS.searchForm(module),
    modal: TEST_ID_PATTERNS.modal(module),
    actions: TEST_ID_PATTERNS.actions(module),
    createBtn: TEST_ID_PATTERNS.createBtn(module),
    editBtn: TEST_ID_PATTERNS.editBtn(module),
    deleteBtn: TEST_ID_PATTERNS.deleteBtn(module),
    queryBtn: TEST_ID_PATTERNS.queryBtn(module),
    resetBtn: TEST_ID_PATTERNS.resetBtn(module)
  };
}
function generateCompleteTestIds(module) {
  return {
    module,
    // 容器
    container: `${module}`,
    table: `${module}-table`,
    form: `${module}-form`,
    searchForm: `${module}-search-form`,
    modal: `${module}-modal`,
    // 按钮（静态）
    queryBtn: `${module}-query-btn`,
    resetBtn: `${module}-reset-btn`,
    createBtn: `${module}-create-btn`,
    // 按钮（动态）
    editBtn: (rowIndex) => `${module}-edit-btn-${rowIndex}`,
    deleteBtn: (rowIndex) => `${module}-delete-btn-${rowIndex}`,
    viewBtn: (rowIndex) => `${module}-view-btn-${rowIndex}`,
    // 弹窗按钮
    modalConfirmBtn: `${module}-modal-confirm-btn`,
    modalCancelBtn: `${module}-modal-cancel-btn`,
    // 表单字段
    formField: (fieldName) => `${module}-form-${fieldName}`,
    searchField: (fieldName) => `${module}-search-${fieldName}`
  };
}

// playwright/utils/api-path.ts
function createApiPaths(basePath, paths) {
  const registry = {};
  for (const key in paths) {
    if (Object.prototype.hasOwnProperty.call(paths, key)) {
      const def = paths[key];
      const fullPath = `${basePath}${def.path}`;
      const pattern = `**${fullPath}`;
      registry[key] = {
        fullPath,
        pattern,
        relativePath: def.path,
        method: def.method || "GET",
        description: def.description
      };
    }
  }
  return registry;
}
function extractFullPaths(registry) {
  return Object.values(registry).map((entry) => entry.fullPath);
}
function extractPatterns(registry) {
  return Object.values(registry).map((entry) => entry.pattern);
}
export {
  TEST_ID_PATTERNS,
  createApiPaths,
  extractFullPaths,
  extractPatterns,
  generateCompleteTestIds,
  generateModuleId,
  generatePageTestIds,
  generateTestId
};
//# sourceMappingURL=utils.mjs.map